// LOGOMAN PRO — generate a QR code as SVG path data fitting our 0..100 viewBox.

import QRCode from "qrcode";

export interface QrPaths {
  paths: string[]; // single-element array containing one combined path
  modules: number; // grid size (e.g. 25 for version 2)
}

/**
 * Generate a QR code path string normalized to a 100x100 viewBox so it can
 * drop directly into our render pipeline as a custom icon.
 */
export async function buildQrPaths(text: string): Promise<QrPaths> {
  if (!text) throw new Error("QR text is empty");

  const qr = QRCode.create(text, { errorCorrectionLevel: "M" });
  const data = qr.modules.data;
  const size = qr.modules.size;
  const cell = 100 / size;

  let d = "";
  for (let row = 0; row < size; row++) {
    for (let col = 0; col < size; col++) {
      if (data[row * size + col]) {
        const x = col * cell;
        const y = row * cell;
        d += `M${x.toFixed(3)} ${y.toFixed(3)}h${cell.toFixed(3)}v${cell.toFixed(3)}h-${cell.toFixed(3)}z`;
      }
    }
  }
  return { paths: [d], modules: size };
}
